
function getColumnSpanClassName(span) {
    span = parseInt(span);
    return `grid-col-${span}`;
}

function getColumnStartClassName(offset) {
    if (offset === '-') {
        return '';
    }
    offset = parseInt(offset);
    return offset > 1 ? `grid-col-start-${offset}` : '';
}

function getRowSpanClassName(span) {
    span = parseInt(span);
    return `grid-row-${span}`;
}

export function getContainerStyle(rowGap, colGap) {
    const gridGap = `${colGap}px ${rowGap}px`;
    return { gridGap };
}

export function getCellClassName(rowSpan, columnSpan, offsetColumn) {
    return [
        getRowSpanClassName(rowSpan),
        getColumnSpanClassName(columnSpan),
        getColumnStartClassName(offsetColumn)
    ]
}




